import {
    ACCEPT_TERMS_OPERATION,
    LIST_USER_DETAILS_OPERATION,
    GET_ACCEPT_TERMS_OPERATION
} from 'app/store/__generated__/operations';
import { clearHistory } from 'app/routes';
import { authLogout } from 'app/store/auth';
import { WEBSOCKET_AUTH } from 'app/store/websocketStatus/types';

import { LIST_USER_DETAILS, GET_ACCEPT_TERMS, ACCEPT_TERMS, SIGN_OUT } from './types.js';

export const doListUserDetails = () => ({
    type: LIST_USER_DETAILS,
    params: { usernames: [] },
    api: LIST_USER_DETAILS_OPERATION
});

export const doWebsocketAuth = (jwt) => ({
    type: WEBSOCKET_AUTH,
    api: { version: 2, name: 'Authenticate' },
    params: { jwt },
    onSucceeded: ({ meta }) => {
        window.europa.sessionId = meta.sessionId;
    }
});

export const doSignOut = () => ({
    type: SIGN_OUT,
    effect: () => {
        authLogout();
        clearHistory();
    }
});

export const doGetUserHasAcceptedTerms = () => ({
    type: GET_ACCEPT_TERMS,
    api: GET_ACCEPT_TERMS_OPERATION
});

export const doAcceptTerms = () => ({
    type: ACCEPT_TERMS,
    api: ACCEPT_TERMS_OPERATION,
    effect: ({ dispatch }) => {
        dispatch(doGetUserHasAcceptedTerms());
    }
});
